import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import type { Tables } from '@/integrations/supabase/types';

export interface RuleAction {
  id?: string;
  type: 'assign_offer';
  value: {
    offer_template_id: string;
  };
}

interface ActionConfigurationRowProps {
  action: RuleAction;
  onUpdate: (updatedAction: RuleAction) => void;
  onRemove: (id: string) => void;
  offerTemplates: Tables<'offer_templates'>[];
}

const ActionConfigurationRow: React.FC<ActionConfigurationRowProps> = ({ action, onUpdate, onRemove, offerTemplates }) => {
  const handleTemplateChange = (offer_template_id: string) => {
    onUpdate({ ...action, value: { ...action.value, offer_template_id } });
  };

  return (
    <div className="rounded-md border bg-card p-2.5">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <Select value={action.type} disabled> {/* Type is fixed for now */}
          <SelectTrigger className="w-full sm:w-[10rem] sm:shrink-0">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="assign_offer">Assign Offer</SelectItem>
          </SelectContent>
        </Select>

        <Select value={action.value.offer_template_id} onValueChange={handleTemplateChange}>
          <SelectTrigger className="w-full sm:flex-1 sm:min-w-[7rem]">
            <SelectValue placeholder="Select an offer to assign" />
          </SelectTrigger>
          <SelectContent>
            {offerTemplates.length > 0 ? (
              offerTemplates.map((template) => (
                <SelectItem key={template.offer_id} value={template.offer_id}>
                  {template.offer_name}
                </SelectItem>
              ))
            ) : (
              <div className="px-2 py-1.5 text-sm text-muted-foreground">
                No offer templates available
              </div>
            )}
          </SelectContent>
        </Select>

        <Button
          variant="ghost"
          size="icon"
          onClick={() => onRemove(action.id!)}
          aria-label="Remove action"
          className="self-end sm:self-auto sm:shrink-0 text-muted-foreground hover:text-status-danger"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default ActionConfigurationRow;
